import { createContext } from "react";

import { PowerBiReport, PowerBiDataset } from "./models/models";

export interface EmbeddingData {
  tenantName: string;
  reports: PowerBiReport[];
  datasets: PowerBiDataset[];
  user: string;
  userCanEdit: boolean;
  userCanCreate: boolean;
  workspaceArtifactsLoading?: boolean;
  loginId: string;
}

export const EmbeddingDataDefaults: EmbeddingData = {
  tenantName: null,
  reports: [],
  datasets: [],
  user: null,
  userCanEdit: null,
  userCanCreate: null,
  workspaceArtifactsLoading: false,
  loginId: null,
};

export interface AppContextProps {
  embeddingData: EmbeddingData;
  refreshEmbeddingData: () => Promise<void>;
}

export const AppContext = createContext<AppContextProps>({
  embeddingData: EmbeddingDataDefaults,
  refreshEmbeddingData: async () => {},
});
